import React from 'react'

function Wait() {
  return (
    <div>Wait page</div>
  )
}

export default Wait